import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
} from '@chakra-ui/react'

export const DeleteSubscriberModal = ({
  isOpen,
  onClose,
  onDelete,
  isLoading,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        {' '}
        <ModalHeader color='red.500'>Confirm Deletion</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            Are you sure you want to delete this subscriber?
            <Text fontSize='sm' color='red.500' mt={2}>
              This action cannot be undone.
            </Text>
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme='red' onClick={onDelete} isLoading={isLoading}>
            Delete
          </Button>
          <Button
            colorScheme='gray'
            mr={3}
            onClick={onClose}
            isDisabled={isLoading}
          >
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
